import { NextSeo, ProductJsonLd } from 'next-seo';
import React from 'react';
import { storeUrl } from '../../../config/config';
import { getMainImage } from '../../utils/utils';

const SEO = ({ product }) => (
  <>
    <NextSeo
      title={product.title}
      description={product.description.long || product.title}
      canonical="https://www.canonical.ie/"
      openGraph={{
        description: product.description.long || product.title,
        title: product.title,
        url: `${storeUrl}/product/${product.slug}`,
        images: [
          {
            alt: getMainImage(product).alt,
            height: getMainImage(product).dimensions.height,
            url: getMainImage(product).url,
            width: getMainImage(product).dimensions.width
          }
        ],
        site_name: 'ToPharmakeio.gr'
      }}
      twitter={{
        cardType: 'summary_large_image',
        handle: '@handle',
        site: '@site'
      }}
    />
    <ProductJsonLd
      aggregateRating={{
        /* TODO: calculate ratings */ ratingValue: '4.4',
        reviewCount: '89'
      }}
      brand={product.brand}
      description={product.description.long || product.title}
      images={[getMainImage(product).url]}
      mpn={product.sku}
      productName="Executive Anvil"
    />
  </>
);

export default SEO;
